import { render } from "./preview-colors.vue?vue&type=template&id=78293538&ts=true"
import script from "./preview-colors.vue?vue&type=script&lang=ts"
export * from "./preview-colors.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__